import React, {
  Component
} from 'react';
import _ from 'lodash';
import moment from 'moment';

class NextDays extends Component {

  constructor(props) {
   super(props);
   this.state = {
     column: null,
     data: this.props.reportData,
     dataArray: this.props.tableData.orderByStatus[this.props.nextDaysObj.type],
     order: true,
   }
  }

  handleSort = clickedColumn => () => {
    const { column, dataArray, order } = this.state

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        dataArray: _.sortBy(dataArray, [clickedColumn]),
        order: true,
      })

      return
    }

    this.setState({
      dataArray: dataArray.reverse(),
      order: !order
    })
  }

  render() {
    const { nextDaysObj, practice } = this.props;
    const { column, order, dataArray } = this.state;
    const direction = order ? 'down' : 'up';
    return (
      <table className="table tableCustomStyle TableHeaderFixed my-0">
        <thead>
          <tr>
            <th className={`cursorPointer ${column === 'practice' ? 'active': ''}`} onClick={this.handleSort('practice')}>
              <div>PRACTICE<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
            <th className={`cursorPointer ${column === 'PatNum' ? 'active': ''}`} onClick={this.handleSort('PatNum')}>
              <div>PAT NUM<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
            <th className={`cursorPointer ${column === 'AptDateTime' ? 'active': ''}`} onClick={this.handleSort('AptDateTime')}>
              <div>APT DATE/TIME<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
            <th className={`cursorPointer ${column === 'statusKey' ? 'active': ''}`} onClick={this.handleSort('statusKey')}>
              <div>APT TYPE<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
            <th className={`cursorPointer ${column === 'AptStatus' ? 'active': ''}`} onClick={this.handleSort('AptStatus')}>
              <div>APT STATUS<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
            <th className={`cursorPointer ${column === 'opName' ? 'active': ''}`} onClick={this.handleSort('opName')}>
              <div>OPERATORY<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
            <th className={`cursorPointer ${column === 'Confirmation_Status' ? 'active': ''}`} onClick={this.handleSort('Confirmation_Status')}>
              <div>CONFIMATION STATUS<i className={`sort amount ${direction} icon ml-05`}></i></div>
            </th>
          </tr>
        </thead>
        <tbody>
          {
            Object.keys(dataArray).length ?
              Object.keys(dataArray).map( key => {
                if(nextDaysObj.confirmed && !dataArray[key].confirmed) {
                  return false;
                }
                return (<tr key={key}>
                  <td>{practice}</td>
                  <td className="primaryColor cursorPointer"><span onClick={() => this.props.openFamilyView(dataArray[key].PatNum, practice)}>{dataArray[key].PatNum}</span></td>
                  <td>{moment(dataArray[key].AptDateTime).utc().format("YYYY-MM-DD hh:mm:ss A")}</td>
                  <td>{(dataArray[key].statusKey==='FV' ? "First Time" : dataArray[key].statusKey==='TX' ? "Treatment" : "Recare" )}</td>
                  <td>{(dataArray[key].AptStatus === 1)?"Schedule":"Broken"}</td>
                  <td>{dataArray[key].opName}</td>
                  <td>{dataArray[key].Confirmation_Status}</td>
                </tr>)
              })
            :
              <tr key="blank"><td colSpan="3">No Record found</td></tr>
          }
        </tbody>
      </table>
    )
  }
}

export default NextDays;
